import { AppState } from 'redux/reducers';

export const getPSFooter = ({ pokerstar }: AppState) => pokerstar.psFooter;
